var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutomationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0505 18H14.5C13.1193 18 12 16.8807 12 15.5C12 14.1193 13.1193 13 14.5 13H24.0505M17.9495 29H27.5C28.8807 29 30 27.8807 30 26.5C30 25.1193 28.8807 24 27.5 24H17.9495M12 26.5C12 28.433 13.567 30 15.5 30C17.433 30 19 28.433 19 26.5C19 24.567 17.433 23 15.5 23C13.567 23 12 24.567 12 26.5ZM30 15.5C30 17.433 28.433 19 26.5 19C24.567 19 23 17.433 23 15.5C23 13.567 24.567 12 26.5 12C28.433 12 30 13.567 30 15.5Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomationIcon);
export default __webpack_public_path__ + "static/media/automationIcon.892586de1796fce1fb176c59510afcd5.svg";
export { ForwardRef as ReactComponent };